import React, { useEffect, useState, useRef } from 'react'
import ModalTest from '../../BaseModal'
import * as S from '../../styles/modal-style'
import { Ellipsis, Plus, Trash, X } from 'lucide-react'
import axios from '../../../config/axios'
import { AddInStep } from '../../../pages/ClientPanel/Pipelines/style'

interface PropsInterface {
  closeModal: () => void
}

const colors = [
  {name: 'Amarelo', color: '#FFEFB7'},
  {name: 'Verde', color: '#B3E4BF'},
  {name: 'Vermelho', color: '#FEC7C9'},
  {name: 'Azul', color: '#99D3EE'},
]

const OptionDiv:React.FC<{children: React.ReactNode, onClick?: () => void}> = ({children, onClick}) => {
  return (
    <S.InputDiv style={{flexDirection: 'row', alignItems: 'center', gap: '.5rem', cursor: 'pointer'}} onClick={onClick}> {children} </S.InputDiv>
  )
}

const ColorDiv:React.FC<{color: string}> = ({color}) => {
  return <div style={{width: '22px', height: '22px', backgroundColor: color, borderRadius: '50%'}} />
}

const ViewOrEditTags: React.FC<PropsInterface> = ({closeModal}) => {
  const [tags, setTags] = useState<any[]>([])
  const [dropDownIndex, setDropDownIndex] = useState<number | null>(null)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [newNameInput, setNewNameInput] = useState<string>('')

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/tag`)
        if(response.data) {
          setTags(response.data.data)
        }
      } catch (error) {
        console.error(error)
      }
    }

    fetchTags()
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropDownIndex(null)
      }
    }

    if (dropDownIndex !== null) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropDownIndex])
  
  const handleIsEditingTag = (index: number) => {
    setDropDownIndex(index)
    setNewNameInput(tags[index].name)
  }
  
  const handleSaveEditedTag = () => {
    setTags(tags.map((tag, index) => index === dropDownIndex ? {...tag, name: newNameInput, updated:true} : tag))
  }

  const handleDeleteTag = () => {
    setTags(tags.filter((tag, index) => index !== dropDownIndex))
    setDropDownIndex(null)
  }

  const handleChangeColor = (index: number, color: string) => {
    setTags(tags.map((tag, index) => index === dropDownIndex ? {...tag, color: color, updated:true} : tag))
  }
  
  const handleSaveTags = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/tag`, tags)
      if(response.data) {
        closeModal()
      }
    } catch (error: any) {
      console.error(error)
      const errorMessage = error?.response?.data?.message || 'Erro ao salvar tags. Tente novamente.'
      alert(errorMessage)
    }
  }

  return (
    <ModalTest>
      <S.ContainerOfModal width='600px'>
        <S.Header>
          <S.HeaderTitle>Tags</S.HeaderTitle>
          <S.CloseDiv onClick={closeModal}> <X size={20} /></S.CloseDiv>
        </S.Header>
        <S.FormContainer onSubmit={(e) => e.preventDefault()}>
          {tags.map((tag, index) => (
            <S.InputDiv key={tag.id || `new-${index}`} style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', position: 'relative'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '.5rem'}}>
                <ColorDiv color={tag.color} />
                <S.Label style={{fontWeight: 400}}>{tag.name}</S.Label>
              </div>
              <Ellipsis size={20} style={{cursor: 'pointer'}} color='#696969' onClick={() => handleIsEditingTag(index)} />
              {dropDownIndex === index && (
                <div ref={dropdownRef} style={{position: 'absolute', top: '100%', right: 0, backgroundColor: 'white', padding: '.8rem', borderRadius: '5px', zIndex: 1, boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)'}}>
                  <S.FormContainer onSubmit={(e) => e.preventDefault()}>
                    <S.Input placeholder='Digite aqui' value={newNameInput} onChange={(e) => setNewNameInput(e.target.value)} autoFocus onBlur={handleSaveEditedTag} />
                    <OptionDiv onClick={handleDeleteTag}>
                      <Trash size={20} style={{cursor: 'pointer'}} color='#BF383B' /> <span style={{fontSize: '15px', fontWeight: 400, color: '#BF383B'}}>Excluir</span>
                    </OptionDiv>
                    {colors.map((color) => (
                      <OptionDiv key={color.name} onClick={() => handleChangeColor(index, color.color)}>
                        <ColorDiv color={color.color} />
                        <S.Label style={{fontWeight: 400}}>{color.name}</S.Label>
                      </OptionDiv>
                    ))}
                  </S.FormContainer>
                </div>
              )}
            </S.InputDiv>
          ))}
        <AddInStep type="button" onClick={() => setTags([...tags, {name: 'Tag', color: '#FFEFB7'}])}><Plus />Criar nova tag</AddInStep>
        </S.FormContainer>
        <S.BottomDiv>
          <S.ButtonContainer>
            <S.Button type="button" onClick={closeModal} className='cancel'>Cancelar</S.Button>
            <S.Button type="button" onClick={handleSaveTags}>Salvar e fechar</S.Button>
          </S.ButtonContainer>
        </S.BottomDiv>
      </S.ContainerOfModal>
    </ModalTest>
  )
}

export default ViewOrEditTags